import { hex2rgba } from '@/helpers/hex-to-rgba'

type ColorValue = string

export enum Color {
  BLACK = 'black',
  WHITE = 'white',
  VIOLET = 'violet',
  VIOLET_LIGHT = 'violetLight',

  BG_DARK = 'bgDark',
  BG_LIGHT = 'bgLight',

  HEADING = 'heading',
  PARAGRAPH = 'paragraph',
  LABEL = 'label',

  GREY = 'grey',
  GREY_LIGHT = 'greyLight',

  ERROR = 'error',
  GREEN = 'green',
  ERROR_BG = 'errorBackground',
  GREEN_BG = 'greenBackground',
  YELLOW = 'yellow',
  YELLOW_GREEN = 'yellowGreen',
  ORANGE = 'orange',
  VIOLET_LIGHT_BG = 'bgVioletLight',
  GREY_LIGHT_BG = 'bgGreyLight',

  PUBLIC_ORANGE = 'publicOrange',
  PUBLIC_PURPLE = 'publicPurple',
}

export enum StatusColor {
  GREEN = 'statusGreen',
  YELLOW_GREEN = 'statusYellowGreen',
  YELLOW = 'statusYellow',
  ORANGE = 'statusOrange',
  VIOLET = 'statusViolet',
  RED = 'statusRed',
  GRAY = 'statusGray',
  WHITE_GREY = 'statusWhiteGray',
}

export interface ThemeColorsProps {
  black: ColorValue
  white: ColorValue
  violet: ColorValue
  violetLight: ColorValue

  bgDark: ColorValue
  bgLight: ColorValue

  heading: ColorValue
  paragraph: ColorValue
  label: ColorValue

  greyLight: ColorValue
  grey: ColorValue

  error: ColorValue
  green: ColorValue
  errorBackground: ColorValue
  greenBackground: ColorValue

  yellow: ColorValue
  yellowGreen: ColorValue
  orange: ColorValue
  bgVioletLight: ColorValue
  bgVioletLightest: ColorValue
  bgGreyLight: ColorValue

  publicOrange: ColorValue
  publicBgLight: ColorValue
  publicNavyLight: ColorValue
  publicPurple: ColorValue
  publicRust: ColorValue
}

export interface ThemeStatusColorsProps {
  statusGreen: ColorValue
  statusYellowGreen: ColorValue
  statusYellow: ColorValue
  statusOrange: ColorValue
  statusViolet: ColorValue
  statusRed: ColorValue
  statusGray: ColorValue
  statusWhiteGray: ColorValue
}

export const colors: ThemeColorsProps = {
  white: '#ffffff',
  black: '#333333',
  violet: '#38047c',
  violetLight: '#7008f7',

  bgDark: '#EBEDF8',
  bgLight: '#F5F6FA',

  heading: '#353540',
  paragraph: '#525865',
  label: '#4D5A6A',

  greyLight: '#C0C5D2',
  grey: '#848B9D',

  error: '#A82020',
  green: '#358C00',
  errorBackground: '#F7E8E8',
  greenBackground: '#EAF4E5',

  yellow: '#CCC522',
  yellowGreen: '#81a911',
  orange: '#CC8822',
  bgVioletLight: hex2rgba('#38047c', 0.1),
  bgVioletLightest: hex2rgba('#38047c', 0.05),
  bgGreyLight: hex2rgba('#4D5A6A', 0.1),

  publicOrange: '#FF8A00',
  publicBgLight: hex2rgba('#D8DAEE', 0.2),
  publicNavyLight: '#D8DAEE',
  publicPurple: '#B35DFF',
  publicRust: '#A32C00',
}

export const statusColors: ThemeStatusColorsProps = {
  statusGreen: hex2rgba('#358C00', 0.2),
  statusYellowGreen: hex2rgba('#81a911', 0.2),
  statusYellow: hex2rgba('#CCC522', 0.2),
  statusOrange: hex2rgba('#CC8822', 0.2),
  statusViolet: hex2rgba('#38047c', 0.2),
  statusRed: hex2rgba('#A82020', 0.2),
  statusGray: hex2rgba('#848B9D', 0.2),
  statusWhiteGray: hex2rgba('#C7D0FF', 0.2),
}
